import { useEffect, useState } from "react";
import { SlNotebook } from "react-icons/sl";
import { GiCoins } from "react-icons/gi";
import { ImUsers } from "react-icons/im";
import { AiOutlineTag } from "react-icons/ai";
import { CiSettings } from "react-icons/ci";
import { RiAdvertisementLine } from "react-icons/ri";
import { NavLink, useLocation } from "react-router-dom";
import { BsShop } from "react-icons/bs";
import { useSelector } from "react-redux";
import { TiMessages } from "react-icons/ti";
import useSideBarMenus from "../../validationSchema/Sidebar.js";
import { IoStarOutline } from "react-icons/io5";

const Sidebar = ({ handleSubSidebar }) => {
  const { theme } = useSelector((state) => state.theme);
  const data = useSideBarMenus();

  const [activeLink, setActiveLink] = useState();
  const location = useLocation();
  const route =
    location.pathname.split("/store/")[1] === undefined
      ? ""
      : location.pathname.split("/store/")[1];
  const activeMenu = data.filter(
    (d) => d.title.toLowerCase() === route.split("/")[0].toLowerCase()
  );

  useEffect(() => {
    setActiveLink(activeMenu);
  }, [location]);


  const iconComponents = {
    BsShop: <BsShop />,
    SlNotebook: <SlNotebook />,
    GiCoins: <GiCoins />,
    ImUsers: <ImUsers />,
    AiOutlineTag: <AiOutlineTag />,
    TiMessages: <TiMessages />,
    CiSettings: <CiSettings />,
    RiAdvertisementLine: <RiAdvertisementLine />,
    IoStarOutline: <IoStarOutline />,
  };

  return data.map((item, i) => (

    <div
      className={` flex-column  ${theme === "light"
          ? "bg-secondaryColor text-primaryColor"
          : "bg-darkThirsary text-darkSecondary"
        } `}
    >

      <NavLink
        key={i}
        className={`${item.path === activeLink?.[0]?.path ? 'active' : ''} flex flex-row gap-2  items-center  cursor-pointer hover:text-hoverColor hover:font-semibold  border p-3 py-3 ${theme === "light"
            ? "bg-secondaryColor border"
            : "bg-darkThirsary border-none"
          }

`}
        to={item.path}
        onClick={() => handleSubSidebar(item)}
      >
        <p className="text-[1.2rem]">{iconComponents[item.icon]}</p>
        <p className="text-[13.6px] ">{item.title}</p>
      </NavLink>

    </div>

  ));
};

export default Sidebar;
